import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Pane, majorScale, minorScale } from 'evergreen-ui'

export default class NavigationBar extends PureComponent {
  static propTypes = {
    /**
     * Background color of the whole navigation bar
     */
    backgroundColor: PropTypes.string,
    /**
     * Component to render in the center.
     * - Title
     * - Title breadcrumb
     */
    centerView: PropTypes.node,

    /**
     * Component to render on the left.
     * - Workspace dropdown
     * - Back button
     * - Cancel button
     */
    leftView: PropTypes.node,

    /**
     * Component to render on the right.
     * - Avatar dropdown
     */
    rightView: PropTypes.node,

    /**
     * Component to render on the left near navigation tabs.
     * - Space menu
     */
    subLeftView: PropTypes.node,

    /**
     * Component to be rendered under the title bar.
     * - TabBar
     * - StepIndicatorBar
     */
    children: PropTypes.node
  }

  static defaultProps = {
    backgroundColor: 'white'
  }

  render() {
    const {
      backgroundColor,
      children,
      centerView,
      rightView,
      leftView,
      subLeftView
    } = this.props
    return (
      <Pane background={backgroundColor} elevation={0} zIndex={2}>
        <Pane display="flex" height={majorScale(7)}>
          <Pane
            flexBasis={majorScale(30)}
            display="flex"
            alignItems="center"
            paddingLeft={minorScale(3)}
          >
            {leftView}
          </Pane>
          <Pane
            className="fade-in-simple"
            flex={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {centerView}
          </Pane>
          <Pane
            paddingRight={minorScale(3)}
            flexBasis={majorScale(30)}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            {rightView}
          </Pane>
        </Pane>
        {(children || subLeftView) && (
          <Pane borderTop="muted" display="flex" paddingY={majorScale(1)}>
            <Pane flex="1" minWidth={0} paddingLeft={majorScale(1)}>
              {subLeftView}
            </Pane>

            <Pane
              flex="2"
              minWidth={0}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {children}
            </Pane>

            <Pane flex="1" minWidth={0} />
          </Pane>
        )}
      </Pane>
    )
  }
}
